import React, { useState } from "react";

import ReportItemHeader from "../../common/ReportItemHeader";

const BenefitTypeList = ({ data, setBenefit, activeBenefit }) => {
  const renderClass = (item) => {
    let _data = data[[activeBenefit]]?.id;
    let _item = item?.id;

    return _item === _data ? "active" : "";
  };

  const [shrink, setShrink] = useState(false);
  return data ? (
    <div className={`report-container _25-per ${shrink && "shrink"}`}>
      <ReportItemHeader
        title={data?.benefit_type}
        shrink={shrink}
        setShrink={setShrink}
      />

      <div className="report-item-list">
         <ul>
           {data?.map(
             (benefit, i) => (
               <li
                   key={i}
                   onClick={() => setBenefit && setBenefit(i)}
                   className={renderClass(benefit)}
               >
                 {benefit?.benefit_type}
               </li>
             )
           )}
         </ul>
      </div>
    </div>
  ) : null;
};

export default BenefitTypeList;
